<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="align-self-center pl-3 mr-auto">
        <div class="d-flex flex-column">
          <div class="titre-h3 secondary--text ">
            Autres charges spécifiques
          </div>
          <div class="titre-h5 secondary--text ">
            <span class="secondary--text align-self-center ">{{ autresCharges[0].typeCulture.nom }}</span>
          </div>
        </div>
      </div>
      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-column mt-3 mx-4">
      <v-card
        v-for="autreCharge in autresCharges"
        :key="autreCharge.id"
        class="pa-2 mb-2 background"
      >
        <div class="d-flex justify-space-between">
          <div class="secondary--text titre-h5">
            {{ autreCharge.typeRubrique.libelleSousRubrique }}
            <v-chip
              v-if="autreCharge.typeRubrique.statut === 'OBLIGATOIRE'"
              small
              color="secondary"
            >
              <span class="text-lowercase">
                {{ autreCharge.typeRubrique.statut | capitalize }}
              </span>
            </v-chip>
          </div>
          <div class="d-flex justify-space-around">
            <AgrButton
              icon
              @click="onOpenUpdateParametreModal(autreCharge)"
            >
              <v-icon color="grey darken-2">
                mdi-pencil-outline
              </v-icon>
            </AgrButton>
            <AgrButton
              v-if="autreCharge.typeRubrique.statut === 'SUPPRIMABLE'"
              icon
              @click="onOpenDeleteParametreModal(autreCharge)"
            >
              <v-icon color="grey darken-2">
                mdi-delete-outline
              </v-icon>
            </AgrButton>
          </div>
        </div>
        <div class="d-flex justify-space-between">
          <div class="texte py-0 texte-gris-fonce font-weight-light">
            Valeur min
          </div>
          <div class="align-self-center texte py-0 secondary--text font-weight-light">
            {{ autreCharge.valeurMin != null ? autreCharge.valeurMin: '-' }} €/ha
          </div>
        </div>
        <div class="d-flex justify-space-between">
          <div class="texte py-0 texte-gris-fonce">
            Valeur défaut
          </div>
          <div class="align-self-center texte py-0 secondary--text">
            {{ autreCharge.valeurDefaut != null ? autreCharge.valeurDefaut: '-' }} €/ha
          </div>
        </div>
        <div class="d-flex justify-space-between">
          <div class="texte py-0 texte-gris-fonce font-weight-light">
            Valeur max
          </div>
          <div class="align-self-center texte py-0 secondary--text font-weight-light">
            {{ autreCharge.valeurMax != null ? autreCharge.valeurMax: '-' }} €/ha
          </div>
        </div>
      </v-card>
      <div class="d-flex justify-space-between my-4">
        <AgrButton
          outlined
          @click="isUpdateParametreModalOpen = true"
        >
          Ajouter une charge
        </AgrButton>
        <AgrButton
          outlined
          @click="onClose()"
        >
          Fermer
        </AgrButton>
      </div>
      <v-dialog
        v-if="isUpdateParametreModalOpen"
        v-model="isUpdateParametreModalOpen"

        width="500"
      >
        <UpdateParametreModal
          :parametre="parametre"
          :type-culture="autresCharges[0].typeCulture"
          :type-rubrique="autresCharges[0].typeRubrique"
          :unite="'€/ha'"
          @close="closeModalNouveauParametre()"
          @updatedParametre="updatedParametre"
        />
      </v-dialog>
      <v-dialog
        v-model="isConfirmDeleteParametreModalOpen"
        persistent
        width="500"
      >
        <ConfirmModal
          title="Confirmation"
          cancel-text="Non"
          confirm-text="Oui"
          @cancel="isConfirmDeleteParametreModalOpen=false"
          @confirm="confirmDeleteParametre()"
        >
          Souhaitez-vous vraiment supprimer ce paramètre ?
        </ConfirmModal>
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import ConfirmModal from '@/components/modal/confirm-modal.vue'
import UpdateParametreModal from './update-parametre-modal.vue'
import { mapActions } from 'vuex'

export default {
  name: 'UpdateAutresChargesModal',
  components: {AgrButton, ConfirmModal, UpdateParametreModal},
  props: {
    autresCharges: {
      type: Array,
      default: null
    }
  },

  data () {
    return {
      loading: false,
      erreur: null,
      isUpdateParametreModalOpen: false,
      isConfirmDeleteParametreModalOpen: false,
      parametre: null,
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis',
      }
    }
  },

  methods: {
    ...mapActions({
      deleteAdminComparateurParametreMarge: 'comparateurMarge/deleteAdminComparateurParametreMarge'
     }),
    
    onClose () {
      this.$emit('close')
    },
    closeModalNouveauParametre () {
      this.isUpdateParametreModalOpen = false
    },
    onOpenUpdateParametreModal (value) {
      this.parametre = value
      this.isUpdateParametreModalOpen = true
    },
    onOpenDeleteParametreModal (value) {
      this.parametre = value
      this.isConfirmDeleteParametreModalOpen = true
    },
    confirmDeleteParametre () {
      this.deleteAdminComparateurParametreMarge(this.parametre)
      .then(()=> this.$emit('updatedParametre', this.autresCharges[0].typeCulture.id))
      this.isConfirmDeleteParametreModalOpen = false
      this.parametre = null
    },
    updatedParametre () {
      this.$emit('updatedParametre', this.autresCharges[0].typeCulture.id)
      this.isUpdateParametreModalOpen = false
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.background {
  background: #EFF0E1;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.input-number {
  width: 100%;
}
</style>
